import { GroupOption } from '@/presentation/components/generalizations/enrolments-table-group-selector/selectors/group-option';
import { GroupOptionsEnums } from '@/models/group-options-enums';

export class IntakeYearGroupOption extends GroupOption {
	public get displayText(): string {
		return 'Year';
	}
	public equals(option: GroupOption): boolean {
		return option instanceof IntakeYearGroupOption;
	}
	public getHashKey(): GroupOptionsEnums {
		return GroupOptionsEnums.INTAKE_YEAR_GROUP_OPTION;
	}
}
